import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import 'rxjs';

import {API_URL, WEB_URL} from '../../../providers/config';

import {Platform} from "@ionic/angular";
import {
    CertificateApiResponse, ClientFeedbackResponse,
    ClientRequestResponse, GroupForTransfer, LessonForTransfer, LessonReportAbsenceResult, LessonTransferResult,
    RegisterApiResponse,
    ResultExamUrl,
    StudentDashboardApiResponse
} from "../../types/apiResponse.interface";
import {BehaviorSubject, map, Observable} from "rxjs";
import {PersistenceService} from "./persistence.service";
import {ApiService} from "./api.service";
import {ClientRequestForm, FeedbackForm} from "../../types/interfaces";
import {AuthService} from "./auth.service";
import {ParentService} from "./parent.service";


let webUrl = WEB_URL;
let apiUrl = API_URL;

@Injectable({providedIn: 'root'})
export class MyGreenCountry {

    private activeGroupTime$ = new BehaviorSubject<string>(this.persistenceService.get('activeGroupTime') as string);


    constructor(
        public http: HttpClient,
        public platform: Platform,
        public apiService: ApiService,
        private persistenceService: PersistenceService,
        private authService: AuthService,
        private parentService: ParentService,
    ) {

        this.activeGroupTime$.subscribe({
            next: (activeGroupTime: string | null) => {

                if (activeGroupTime) {
                    this.persistenceService.set('activeGroupTime', activeGroupTime);

                }

            }

        })


    }


    openUrl(url: string, target = '_blank') {

        //@TODO: dynamic
        const isApp = false;

        let frm = document.createElement('form')
        frm.method = 'get';
        frm.target = target
        frm.action = url;


        let oUrl = new URL(url);

        const searchParams = new URLSearchParams(oUrl.searchParams);

        searchParams.forEach((val, key) => {

            let input = document.createElement('input')

            input.type = 'hidden'
            input.name = key
            input.value = val

            frm.appendChild(input)

        });

        if (isApp) {

            // return Browser.open({ url: url })
            return window.location.href = url;

        } else {

            // window.location.href = url;
            // return;

            const isIOS = (navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/Macintosh/))
                && !navigator.userAgent.match(/Chrome/)
                && !navigator.userAgent.match(/Firefox/);

            //@ts-ignore
            document.querySelector('body').appendChild(frm)

            return new Promise((res, rej) => {

                if (isIOS || navigator.userAgent.match(/Firefox/)) {
                    window.location.href = url;
                } else {
                    frm.submit()
                }
                // frm.dispatchEvent(new Event('submit'))

                res(true)

            })

        }


    }


    saveDeviceToken(student_id: String, phone: String, device_uuid: any, token: String, platform: String, version: String, manufacturer: any) {

        return this.apiService.sendApiRequest('/dashboard/save_device_token', {
            student_id: student_id,
            phone: phone,
            token: token,
            platform: platform,
            version: version,
            device_uuid: device_uuid,
            manufacturer: manufacturer
        }, 'post');

    }

    public openCertificate(uuid: String): Observable<CertificateApiResponse> {

        return this.apiService
            .sendApiRequest('/certificate', {uuid: uuid}, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        html: response.html,
                        successes: response.successes
                    };
                })
            );
    }

    public cleanCacheEBook(groupId: number, lessonNumber: string = ''): Observable<any> {
        return this.apiService
            .sendApiRequest('/clean-cache-ebook', {groupId: groupId, lessonNumber:lessonNumber}, 'post')
            .pipe(
                map((response: any) => {

                })
            );

    }

    private handleHttpError(error: any) {

        console.log(error);
        return error.json().message || 'Server error, please try again later';

    }

    public sendClientRequest(form: ClientRequestForm): Observable<ClientRequestResponse> {

        return this.apiService
            .sendApiRequest('/client-request', {
                name: form.contactName,
                phone: form.contactPhone,
                childPhone: form.childPhone,
                contacts: form.contacts,
                text: form.text
            }, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                    };
                })
            );

    }

    public sendFeedback(form:FeedbackForm): Observable<ClientFeedbackResponse> {
        return this.apiService
            .sendApiRequest('/client-feedback', {
                feedback: form.feedback,
                mark: form.mark,
                role: form.role,
                studentId: this.parentService.getActiveChildId(),
            }, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                        message: response.message,
                        responseMark:response.mark
                    };
                })
            );
    }

    public updateAvatar(imageFile: File): Observable<ClientRequestResponse> {
        let formData = new FormData();
        let studentId = this.parentService.getActiveChildId();
        formData.append('avatar', imageFile, imageFile.name);
        formData.append('studentId', studentId.toString());

        return this.apiService
            .sendApiRequest('/update-avatar',formData, 'post', true)
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                    };
                })
            );
    }

    public deleteAvatar(): Observable<ClientRequestResponse> {
        let studentId = this.parentService.getActiveChildId();

        return this.apiService
            .sendApiRequest('/delete-avatar',{studentId: studentId}, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                    };
                })
            );
    }


    getActiveGroupTime(): BehaviorSubject<string> {

        return this.activeGroupTime$;

    }

    setActiveGroupTime(time: string): void {

        this.activeGroupTime$.next(time);
    }

    getCertificateUrlDownload(url:string) {
        return webUrl + '/certificate/download?url=' + url;
    }

    getCertificateUrl(uuid:string) {
        return apiUrl + '/certificate/'+uuid + '/download-image';
    }

    public getExamResultsUrl(phone: String, uuid: String): Observable<ResultExamUrl> {

        return this.apiService
            .sendApiRequest('/exam-results-url', {phone: phone, uuid: uuid}, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.data.success,
                        message: response.data.message,
                        url: response.data.url
                    };
                })
            );


    }


    public getGroupsWithLessonsForTransfer(groupIds: Array<number>): Observable<GroupForTransfer> {
        let data: { groupIds: Array<number>, studentId?: number } = {groupIds};

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }

        return this.apiService
            .sendApiRequest('/groups-for-transfer', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        studentId: response.student_id,
                        groups: response.groups
                    };
                })
            );
    }


    public getLessonsForTransfer(groupId: number, lessonId: number): Observable<LessonForTransfer> {

        let data: { groupId: number, lessonId: number, studentId?: number, isChild?:boolean} = {groupId, lessonId};

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }

        data.isChild = this.authService.isStudentRole();

        return this.apiService
            .sendApiRequest('/lessons-for-transfer', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                        lessonsTo: response.lessonsTo,
                        lessonFrom: response.lessonFrom,
                        byTagsLogic: response.byTagsLogic,
                        tagsText:response.tagsText,
                        courseTypeTitle:response.courseTypeTitle,

                    };
                })
            );
    }


    public createLessonTransfer(groupId: number, fromLessonId: number, toLessonId: number): Observable<LessonTransferResult> {

        let data: { groupId: number, fromLessonId: number, toLessonId: number, studentId?: number } = {
            groupId,
            fromLessonId,
            toLessonId,
        };

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }


        return this.apiService
            .sendApiRequest('/create-lesson-transfer', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                        toLesson: response.toLesson,
                        transferRecordId: response.transferRecordId,

                    };
                })
            );
    }


    public cancelLessonTransfer(lessonId: number, transferId: number) {

        let data: { lessonId: number, transferId: number, studentId?: number } = {
            lessonId,
            transferId
        };

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }


        return this.apiService
            .sendApiRequest('/cancel-lesson-transfer', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,

                    };
                })
            );
    }

    public getGroupsWithLessonsForReportAbsence(groupIds: Array<number>): Observable<GroupForTransfer> {
        let data: { groupIds: Array<number>, studentId?: number } = {groupIds};

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }

        return this.apiService
            .sendApiRequest('/groups-for-report-absence', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        studentId: response.student_id,
                        groups: response.groups
                    };
                })
            );
    }

    public static getLanguage() {
        return localStorage.getItem('language');
    }

    public setLanguage(lang:string):void {
        localStorage.setItem('language',lang);
    }

    public createReportAbsence(groupId: number, lessonId: number): Observable<LessonReportAbsenceResult> {

        let data: { groupId: number, lessonId: number, studentId?: number } = {
            groupId,
            lessonId
        };

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }


        return this.apiService
            .sendApiRequest('/create-report-absence', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,
                    };
                })
            );
    }

    public cancelReportAbsence(lessonId: number, groupId?: string) {

        let data: { lessonId: number, groupId?: string, studentId?: number } = {
            lessonId,
            groupId
        };

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }


        return this.apiService
            .sendApiRequest('/cancel-report-absence', data, 'post')
            .pipe(
                map((response: any) => {
                    return {
                        success: response.success,

                    };
                })
            );
    }

    public setAction(action: string) {

        let data: { action: string, studentId?: number } = {
            action
        };

        if (this.authService.isParent()) {
            data.studentId = this.parentService.getActiveChildId();
        }

        return  this.apiService
            .sendApiRequest('/set-action', data, 'post') .pipe(
                map((response: any) => {
                    return {
                    };
                })
            );
    }

    //
    // public register(form: any): Observable<RegisterApiResponse> {
    //
    //     return this.apiService.sendApiRequest('/registration',
    //         {
    //             studentFirstName: form.studentFirstName,
    //             studentLastName: form.studentLastName,
    //             studentGender: form.studentGender,
    //             studentSchoolClass: form.studentSchoolClass,
    //             birthday: form.birthday,
    //             studentPhone: form.studentPhone,
    //             parentPhone: form.parentPhone,
    //             parentName: form.parentName,
    //             parentEmail: form.parentEmail,
    //             agreement: form.agreement,
    //         }, 'post').pipe(
    //         map((response: any) => {
    //
    //             if (response.token) {
    //                 this.persistenceService.setToken(response.token);
    //             }
    //
    //             return {
    //                 token: response.token,
    //                 urlTest: response.urlTest,
    //             };
    //         })
    //     );
    // }
}
